import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';

import type { AgentsAwarenessModalConnectedProps } from '../src/AgentsAwarenessModalConnected.tsx';

export const AgentsAwarenessModalLoadable: LoadableType<AgentsAwarenessModalConnectedProps> =
	LoadableBackground({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-AgentsAwarenessModalConnected" */
					'../src/AgentsAwarenessModalConnected.tsx'
				)
			).AgentsAwarenessModalConnected,
	});
